























import Vue, { CreateElement, RenderContext } from 'vue';
import { defineComponent, computed } from '@vue/composition-api';
import { WokDataGridConfiguration } from './abstractions';

export default defineComponent({
    name: 'WokDataGridColumnsHeader',

    props: {
        cfg: {
            required: true
        }
    },

    setup(props, context) {
        const columns = computed(() => {
            return (<WokDataGridConfiguration>props.cfg).columns.filter(x => x.headerSpan > 0);
        })

        return {
            columns
        }
    }
})
